export const agencyQueryKeys = {
  _base: () => ["agency-new"],
  all: () => [...agencyQueryKeys._base()],
  single: (agencyId: string) => [...agencyQueryKeys.all(), { agencyId }],
  enquiries: (agencyId: string) => [
    ...agencyQueryKeys.single(agencyId),
    "enquiries",
  ],
  enquiriesByPerson: (agencyId: string, personId?: string) => [
    ...agencyQueryKeys.enquiries(agencyId),
    { personId },
  ],
};
